import { useQuery } from "react-query"
import { getConsultationCalendarEvents } from "./calendarApi"

export const useConsultationCalendarEvents = (customerId: number | undefined) => {
  return useQuery(
    ['consultation-calendar-events', { customerId }],
    () => getConsultationCalendarEvents(customerId),
    {
      enabled: !!customerId,
      staleTime: 1000 * 60
    },
  )
}